<template>
  <div class="animated fadeIn list-of-unearnsettle">
    <b-card>
      <div slot="header">{{this.$route.meta.title}}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <!-- <b-button variant="primary mr-1" @click="edit">Edit</b-button> -->
          <!-- <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button> -->
          <b-button variant="primary mr-1" @click="posting()">Posting</b-button>
          <!-- <b-button variant="primary mr-1" @click="printjv()"><i class="fa fa-print"></i> Print JV</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button> -->
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
       <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col lg="12">
                  <b-input-group >
                    <b-input-group-prepend><label style="width:120px;">Refund Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>  
            <b-row>
              <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label class="pt-2">Debitur</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.customer" placeholder="Debitur Name"></b-form-input>
                  </b-input-group> 
              </b-col>
              <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label class="pt-2">Debitur No.</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.customer" placeholder="Debitur No."></b-form-input>
                  </b-input-group> 
              </b-col>
            </b-row>           
            <b-row>
              <b-col lg="12">
                  <b-input-group >
                    <b-input-group-prepend><label style="width:120px;">Payment Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="AR Invoice Number"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row> 
            
        </b-col>
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label style="width:115px;">Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label style="width:115px;">Destination Bank</label></b-input-group-prepend>
                <b-form-input v-model="tblData.namabank" placeholder="Cash/Bank Name"></b-form-input>
                <b-form-input v-model="tblData.reference" placeholder="Reference/cek/giro" class="ml-1"></b-form-input>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="12">
                  <b-input-group >
                    <b-input-group-prepend><label style="width:115px;">Payment Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldue1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldue2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="12">
                   <div style="text-align:right;margin-top:5px;">
                    <b-button variant="success" size="sm" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                   </div>
                </b-col>
            </b-row>    
                                    
        </b-col>
      </b-row>
      <b-table
        class="mb-0 mt-2"
        ref="table"
        outlined
        responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked" 
      >
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th variant="primary" colspan="5" class="text-center">ADJUSTMENT</b-th>
            <b-th variant="dark" colspan="7">UNEARNED INCOME(PBB)/PREPAID</b-th>
          </b-tr>
        </template>
      <template v-slot:cell(action)="data">
        <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Un Posting</b-dropdown-item>
          <!-- <b-dropdown-item @click="rowPrint(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;"> Delete</b-dropdown-item> -->
        </b-dropdown>
      </template>    
        <template v-slot:cell(settleno)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">{{data.item.settleno}}</div>
          <div v-else>{{data.item.settleno}}</div>
        </template>

        <template v-slot:cell(tglsettl)="data">
          {{ data.item.tglsettl | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(post_date)="data">
          {{ data.item.post_date | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(post_date_adj)="data">
          {{ data.item.post_date_adj | moment("DD MMM YYYY") }}
        </template>
        

        <template v-slot:cell(settleamt_line)="data">
          {{data.item.settleamt_line|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(tglpaym)="data">
          {{ data.item.tglpaym | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(totalbyr)="data">
          {{data.item.matauang}}
          {{data.item.totalbyr|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(pbb_amt)="data">
          {{data.item.pbb_amt|numFormat}}
        </template>
      </b-table>
      <b-row >
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>

  </div>
</template>

<style lang="scss">
.list-of-unearnsettle {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
}
</style>


<script>
import arpbbadjust from '../../apis/fin_arpbbadjust';
import dropdown from "../../data/dropdown";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();


export default {
  data() {
    return {
      showFilter: true,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading:false,
      isprintjv:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      model:{},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        tgl1:moment(this.$store.state.user.tglaktif,'YYYY-MM-DD').startOf('year').format('YYYY-MM-DD'),
        tgl2:this.$store.state.user.akhirbln,        
        sortBy: 'tglsettl',
        sortDesc: true,
      },
      dataList: {
        postingStatus: dropdown.postingStatus
      }      
    };
  },
  components: {Loading},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "action",
            label: "",
            thStyle: "width:20px",
            thClass: "text-center",
          },
          {
            key: "settleno",
            label: "Adjustment #",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "tglsettl",
            label: "Adjustment Date",
            thStyle: "width:90px",
            variant: "primary",
            sortable: true
          },
          {
            key: "post_date_adj",
            label: "Post Date",
            thStyle: "width:90px",
            variant: "primary",
            sortable: true
          },
          {
            key: "settleuraian",
            label: "Description",
          },
          {
            key: "settleamt_line",
            label: "Adjusted Amount",
            thStyle: "width:120px",
            variant: "primary",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "glAccount",
            label: "Adjust to Acc.",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "paymno",
            variant: "secondary",
            label: "Payment Number",
            sortable: true
          },
          {
            key: "tglpaym",
            label: "Payment Date",
            sortable: true
          },
          {
            key: "post_date",
            label: "Post Date",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "paymethod",
            label: "Payment Method",
          },
          {
            key: "namabank",
            label: "Destination Bank/Acc.",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "pbb_ost",
            label: "Prepaid/PBB Amount",
            thStyle: "width:120px",
            variant: "secondary",
            thClass: "text-right",
            tdClass: "text-right"
          }
        ];
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      const filter = this.$store.state.filter;
      let filtered=false;
      for (var key in filter.unearnsettle) {
          this.tblData[key] = filter.unearnsettle[key];
          filtered=true;
      }
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.unearnsettle) {
            this.tblData[key] = filter.unearnsettle[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.unearnsettle.tgl1 || '';
          this.tblData.tgl2=filter.unearnsettle.tgl2 || '';
          this.showFilter=filtered;
          delete filter.unearnsettle;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await arpbbadjust.list(this.tblData);      
      return list;
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.namabank= '';
        this.tblData.reference=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.tgldue1=  '';
        this.tblData.tgldue2=  '';
        this.tblData.status='';
        this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];
      let filtered = false;
      const unearnsettle={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              unearnsettle[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          unearnsettle.page=this.tblData.page;
          unearnsettle.limit=this.tblData.limit;
          unearnsettle.sortBy=this.tblData.sortBy;
          unearnsettle.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.unearnsettle=unearnsettle;
          this.$store.commit("filter", filter);
      }
    },       
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    add(){
      this.saveFilter();
      router.push({name :"loan.prepaidadjusmentform"});
    },
    edit: function() {
        if (this.model.settleKey) {
          this.saveFilter();
          router.push({name :'loan.prepaidadjusmentform', params: { settleKey: this.model.settleKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.settleKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await arpbbadjust.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      // if (this.model.settleKey == record.settleKey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    posting: async function () {
        if (this.model) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await arpbbadjust.posting(this.model);
            this.model.posting=1;
            // this.printjv();
            this.$refs.table.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await arpbbadjust.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
            this.$refs.table.refresh();
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    editjv: function() {
        if (this.model.settleKey) {
            this.saveFilter();
            const tanggal = moment(this.model.tglsettl).format('YYYY-MM-DD');
          router.push({name :'receivable.editjvfrm', params: { nomor: this.model.settleno, tanggal, kodejurnal:'ARSTTL'}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },

    printjv: async function()
    {
      if (this.model.settleKey) {
          // if ((this.model.posting || 0) == 0) {
          //       toastr.warn('Please do Posting first!');
          // }
          try {
              if ((this.model.posting || 0) == 0) {
                await arpbbadjust.posting(this.model);
                this.model.posting=1;
              }
              this.showReport=true;
              this.isprintjv=true;
              this.reportUrl= await arpbbadjust.printjv(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }          
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await arpbbadjust.exportXls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/receivable/home");
    }
  }
};
</script>
